
/* injects from baggage-loader */

'use strict';

import ProjectInvestmentWizardStep2Controller from './projectinvestmentwizard.step2.controller';
import ProjectInvestmentWizardStep2Template from './projectinvestmentwizard.step2.html';

export default class ProjectInvestmentWizardStep2Component {
		constructor() {
				this.templateUrl = ProjectInvestmentWizardStep2Template;
				this.controller = ProjectInvestmentWizardStep2Controller;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				// this.bindings = { };
		}
}



// WEBPACK FOOTER //
// ./src/app/pages/projectInvestmentWizard/step2/projectinvestmentwizard.step2.component.js